import React, { useState, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Switch } from "@headlessui/react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { baseUrl } from "../../Environments/environment";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";

import { toast } from "react-toastify";
import { apiClient } from "../../api";

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

const statusoptions = [
	{ id: 1, text: "Reservation" },
	{ id: 2, text: "In House" },
	{ id: 3, text: "Checked Out" },
];
let ArrivalDate = null;
let ArrivalTime = null;
let DepartureDate = null;
let DepartureTime = null;

let todayDate = null;
let tomorrowDate = null;
let standardCheckInTime = null;
let standardCheckOutTime = null;

const EditGuestModal = ({ isOpen, onClose, guest }) => {
	// console.log(guest);
	const { accessToken } = useAuth();
	const selectedStatus = guest.status.currentStatus;
	const { selectedPropertyId } = useProperty();
	const [selectedDiv, setSelectedDiv] = useState();
	const [currentStatus, setCurrentStatus] = useState(selectedStatus);
	const [roomNumber, setRoomNumber] = useState(undefined);
	const [arrivalDate, setArrivalDate] = useState();
	const [arrivalTime, setArrivalTime] = useState();
	const [departureDate, setDepartureDate] = useState();
	const [departureTime, setDepartureTime] = useState();
	const [sendMessage, setSendMessage] = useState(true);
	const [isMessageVisible, setIsMessageVisible] = useState(false);
	const [message, setMessage] = useState();
	const [checkInType1, setCheckInType1] = useState("Check In");
	const [checkInType2, setCheckInType2] = useState("Check Out");

	const checkIn = `${arrivalDate}T${arrivalTime}Z`;
	const checkOut = `${departureDate}T${departureTime}Z`;

	useEffect(() => {
		if (selectedStatus === "Reservation") {
			setSelectedDiv(0);
		} else if (selectedStatus === "In House") {
			setSelectedDiv(1);
		} else if (selectedStatus === "Checked Out") {
			setSelectedDiv(2);
		} else {
			setSelectedDiv(0); // Default value if no match
		}
		// eslint-disable-next-line
	}, [guest, isOpen]);

	useEffect(() => {
		if (guest) {
			const checkIn = guest.checkIn;
			ArrivalDate = checkIn.split("T")[0];
			ArrivalTime = checkIn.split("T")[1].split(".")[0].slice(0, 5);
			const checkOut = guest.checkOut;
			DepartureDate = checkOut.split("T")[0];
			DepartureTime = checkOut.split("T")[1].split(".")[0].slice(0, 5);

			setArrivalDate(ArrivalDate);
			setArrivalTime(ArrivalTime);
			setDepartureDate(DepartureDate);
			setDepartureTime(DepartureTime);
		}
	}, [guest, isOpen]);

	useEffect(() => {
		if (guest && guest.roomNumber) {
			setRoomNumber(guest.roomNumber);
		}
	}, [guest, isOpen]);

	useEffect(() => {
		console.log("guest status", guest.status.reservationStatus);
		if (guest && guest.status.earlyCheckInStatus === "Accepted") {
			setCheckInType1("Early Check In");
		} else if (
			guest &&
			guest.status.currentStatus === "Reservation" &&
			guest.status.reservationStatus === "Cancelled"
		) {
			setCheckInType1("Cancel Reservation");
		} else if (
			guest &&
			guest.status.currentStatus === "Reservation" &&
			guest.status.reservationStatus === "No Show"
		) {
			setCheckInType1("No Show");
		} else {
			setCheckInType1("Check In");
		}

		if (guest && guest.status.lateCheckOutStatus === "Accepted") {
			setCheckInType2("Late Check Out");
		} else {
			setCheckInType2("Check Out");
		}
		// eslint-disable-next-line
	}, [guest, isOpen]);

	useEffect(() => {
		if (
			guest &&
			guest.status.earlyCheckInStatus === "Not Requested" &&
			checkInType1 === "Early Check In"
		) {
			setArrivalTime("");
		} else if (
			guest &&
			guest.status.earlyCheckInStatus === "Accepted" &&
			checkInType1 === "Check In"
		) {
			setArrivalDate(todayDate);
			setArrivalTime(standardCheckInTime);
		} else if (
			guest &&
			guest.status.earlyCheckInStatus === "Accepted" &&
			checkInType1 === "Early Check In"
		) {
			setArrivalDate(ArrivalDate);
			setArrivalTime(ArrivalTime);
		} else if (
			checkInType1 === "Check In" ||
			checkInType1 === "Cancel Reservation" ||
			checkInType1 === "No Show"
		) {
			setArrivalDate(ArrivalDate);
			setArrivalTime(ArrivalTime);
		}
	}, [guest, checkInType1]);

	const setTiming = async () => {
		try {
			if (!standardCheckInTime || !standardCheckOutTime) {
				const response = await apiClient.get(
					`${baseUrl}/setting/${selectedPropertyId}`,
				);

				standardCheckInTime = response.data.result.setting.standardCheckinTime;
				standardCheckOutTime =
					response.data.result.setting.standardCheckoutTime;
			}
		} catch (error) {
			console.error("Error submitting data:", error);
		}
	};

	useEffect(() => {
		setTiming();
		// eslint-disable-next-line
	}, [isOpen]);

	useEffect(() => {
		const today = new Date();
		const tomorrow = new Date();
		tomorrow.setDate(today.getDate() + 1);

		const formatDate = (date) => {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const day = String(date.getDate()).padStart(2, "0");
			return `${year}-${month}-${day}`;
		};

		todayDate = formatDate(today);
		tomorrowDate = formatDate(tomorrow);
	}, [isOpen]);

	useEffect(() => {
		if (
			guest &&
			guest.status.lateCheckOutStatus === "Not Requested" &&
			checkInType2 === "Late Check Out"
		) {
			setDepartureTime("");
		} else if (
			guest &&
			guest.status.lateCheckOutStatus === "Accepted" &&
			checkInType2 === "Check Out"
		) {
			setDepartureDate(tomorrowDate);
			setDepartureTime(standardCheckOutTime);
		} else if (
			guest &&
			guest.status.lateCheckOutStatus === "Accepted" &&
			checkInType2 === "Late Check Out"
		) {
			setDepartureDate(DepartureDate);
			setDepartureTime(DepartureTime);
		} else if (
			checkInType2 === "Check Out" ||
			checkInType1 === "Cancel Reservation" ||
			checkInType1 === "No Show"
		) {
			setDepartureDate(DepartureDate);
			setDepartureTime(DepartureTime);
		}
		// eslint-disable-next-line
	}, [guest, checkInType2]);
	if (!isOpen) return null;

	const handleChangeStatus = async () => {
		let status = { currentStatus };
		if (checkInType1 === "Early Check In") {
			status.earlyCheckInStatus = "Accepted";
		} else if (
			guest.status.earlyCheckInStatus === "Accepted" &&
			checkInType1 === "Check In"
		) {
			status.earlyCheckInStatus = "Declined";
		}
		if (checkInType1 === "Cancel Reservation") {
			status.reservationStatus = "Cancelled";
		}
		if (checkInType1 === "No Show") {
			status.reservationStatus = "No Show";
		}
		if (checkInType2 === "Late Check Out") {
			status.lateCheckOutStatus = "Accepted";
		} else if (
			guest.status.lateCheckOutStatus === "Accepted" &&
			checkInType2 === "Check Out"
		) {
			status.lateCheckOutStatus = "Declined";
		}
		if (
			guest.status.reservationStatus === "Cancelled" &&
			checkInType1 !== "Cancel Reservation" &&
			checkInType1 !== "No Show"
		) {
			status.reservationStatus = "Confirmed";
		}
		let updatedGuestData = {};
		let guestId = "";
		if (guest) {
			updatedGuestData = {
				email: guest.email,
				source: guest.source,
				status,
				checkIn: checkIn,
				checkOut: checkOut,
				lastName: guest.lastName,
				firstName: guest.firstName,
				countryCode: guest.countryCode,
				phoneNumber: guest.phoneNumber,
				confirmationNumber: guest.confirmationNumber,
				sendMessage: sendMessage,
				...(currentStatus !== "Reservation" && { roomNumber: roomNumber }),
			};
			guestId = guest._id;
		}

		// console.log(updatedGuestData);
		try {
			console.log("urllll", baseUrl);
			// eslint-disable-next-line
			const response = await apiClient.put(
				`${baseUrl}/guest/${selectedPropertyId}/${guestId}`,
				updatedGuestData,
			);

			toast.success(response.data.message);
			onClose();
		} catch (error) {
			// console.log(error.response?.data?.error);
			let errorMessage =
				error.response?.data?.message ||
				"Failed to update the guest. Please try again.";
			if (error.response?.data?.error.checkIn !== undefined) {
				errorMessage = "For Check In " + error.response?.data?.error.checkIn[0];
			} else if (error.response?.data?.error.checkOut !== undefined) {
				errorMessage =
					"For Check Out " + error.response?.data?.error.checkOut[0];
			} else if (error.response?.data?.error.roomNumber !== undefined) {
				errorMessage = error.response?.data?.error.roomNumber[0];
			}
			toast.error(errorMessage);
		}
	};
	const handleDivClick = (index, text) => {
		if (selectedDiv === index) {
			if (selectedStatus === "Reservation") {
				setSelectedDiv(0);
			} else if (selectedStatus === "In House") {
				setSelectedDiv(1);
			} else if (selectedStatus === "Checked Out") {
				setSelectedDiv(2);
			} else {
				setSelectedDiv(0); // Default value if no match
			}
			setCurrentStatus(selectedStatus);
		} else {
			setSelectedDiv(index);
			setCurrentStatus(text);
		}
	};

	const toggleMessageVisibility = () => {
		setIsMessageVisible(!isMessageVisible);
	};

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
			<div className="bg-white p-8 rounded-lg shadow-xl lg:w-[70vh] overflow-x-auto space-y-7">
				<div className="flex justify-between items-center">
					<h2 className="text-lg font-semibold">Edit Guest</h2>
					<button
						onClick={onClose}
						className="text-gray-600 hover:text-gray-900"
					>
						<AiOutlineClose size={20} />
					</button>
				</div>
				<div className="w-full space-y-7">
					<div className="flex items-center justify-between">
						{statusoptions.map((div, index) => (
							<div
								key={div.id}
								className={`flex items-center justify-center h-[7vh] w-[19vh] p-4 border border-solid rounded-[2vh] border-[#D1D5DB] cursor-pointer text-center text-sm font-semibold ${
									selectedDiv === index
										? "bg-[#EEF2FF] border-indigo-600"
										: "bg-white text-black"
								}`}
								onClick={() => handleDivClick(index, div.text)}
							>
								{div.text}
							</div>
						))}
					</div>

					<div className="w-full">
						<label className="block text-[13px] font-semibold text-gray-700 mb-1">
							Registration Details
						</label>

						<div className="flex">
							<div className="w-1/2">
								<select
									value={checkInType1}
									onChange={(e) => setCheckInType1(e.target.value)}
									placeholder="Car Type"
									className={`block w-full border border-b-0 rounded-tl-md border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-gray-900 text-[13px] placeholder:text-gray-300 placeholder:font-light ${
										checkInType1 === "Cancel Reservation" ||
										checkInType1 === "No Show"
											? "bg-rose-50"
											: ""
									}`}
								>
									<option value="Check In">Check In</option>
									<option value="Early Check In">Early Check In</option>
									<option value="Cancel Reservation">Cancel Reservation</option>
									<option value="No Show">No Show</option>
								</select>
							</div>
							<div className="w-1/2">
								<select
									value={checkInType2}
									onChange={(e) => setCheckInType2(e.target.value)}
									placeholder="Car Type"
									className="block w-full border border-b-0 rounded-tr-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-gray-900 text-[13px] placeholder:text-gray-300 placeholder:font-light"
								>
									<option value="Check Out">Check Out</option>
									<option value="Late Check Out">Late Check Out</option>
								</select>
							</div>
						</div>

						<div className="flex mb-4">
							<div className="w-1/4">
								<input
									type="date"
									id="arrivalDate"
									value={arrivalDate}
									onChange={(e) => {
										const newArrival = e.target.value;
										setArrivalDate(newArrival);

										setDepartureDate(
											new Date(newArrival) >= new Date(departureDate)
												? new Date(
														new Date(newArrival).getTime() +
															24 * 60 * 60 * 1000,
													)
														.toISOString()
														.split("T")[0]
												: departureDate,
										);
									}}
									className={`block w-full border border-r-0 rounded-bl-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500  text-[13px] ${
										checkInType1 === "Check In" ||
										checkInType1 === "Cancel Reservation" ||
										checkInType1 === "No Show"
											? "text-gray-400"
											: "text-gray-900"
									}`}
								/>
							</div>
							<div className="w-1/4">
								<input
									type="time"
									id="arrivalTime"
									value={arrivalTime}
									disabled={checkInType1 === "Check In" ? true : false}
									onChange={(e) => {
										setArrivalTime(e.target.value);
									}}
									className={`block w-full border border-l-0 border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] ${
										checkInType1 === "Check In" ||
										checkInType1 === "Cancel Reservation" ||
										checkInType1 === "No Show"
											? "text-gray-400"
											: "text-gray-900"
									}`}
								/>
							</div>
							<div className="w-1/4">
								<input
									type="date"
									id="departureDate"
									value={departureDate}
									onChange={(e) => setDepartureDate(e.target.value)}
									className={`block w-full border border-r-0 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] ${
										checkInType2 === "Check Out" ||
										checkInType1 === "Cancel Reservation" ||
										checkInType1 === "No Show"
											? "text-gray-400"
											: "text-gray-900"
									}`}
								/>
							</div>
							<div className="w-1/4">
								<input
									type="time"
									id="departureTime"
									value={departureTime}
									disabled={
										checkInType2 === "Check Out" &&
										checkInType1 !== "Cancel Reservation" &&
										checkInType1 !== "No Show"
											? true
											: false
									}
									onChange={(e) => setDepartureTime(e.target.value)}
									className={`block w-full border border-l-0 rounded-br-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 text-[13px] ${
										checkInType2 === "Check Out" ||
										checkInType1 === "Cancel Reservation" ||
										checkInType1 === "No Show"
											? "text-gray-400"
											: "text-gray-900"
									}`}
								/>
							</div>
						</div>

						{selectedDiv === 0 ? (
							<></>
						) : (
							<>
								<div className="w-full">
									<label className="block text-[13px] font-semibold text-gray-700 mb-1">
										Room Number
									</label>
									<input
										type="text"
										value={roomNumber}
										onChange={(e) => setRoomNumber(e.target.value)}
										className="block w-full border rounded-md border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 text-[13px] placeholder:font-light"
									/>
								</div>
							</>
						)}
					</div>
				</div>
				<div>
					<div className="flex flex-col lg:flex-row items-center justify-between">
						{/* Switch */}
						<div className="flex items-center mb-2 lg:mb-0">
							<Switch
								checked={sendMessage}
								onChange={setSendMessage}
								className={classNames(
									sendMessage ? "bg-indigo-600" : "bg-gray-200",
									"relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
								)}
							>
								<span className="sr-only">Use setting</span>
								<span
									aria-hidden="true"
									className={classNames(
										sendMessage ? "translate-x-5" : "translate-x-0",
										"pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
									)}
								/>
							</Switch>
							<div className="justify-start">
								<div>
									<label
										htmlFor="toggle"
										className="ml-2 text-[13px] font-medium text-[#111827]"
									>
										Message Guest
									</label>
								</div>
								{/* <label
                  htmlFor="toggle"
                  className="ml-2 text-sm font-medium text-[#111827]"
                >
                  Message Guest
                </label> */}
								<div className="-mt-1.5">
									<button
										className="text-gray-400 pl-2 text-xs"
										onClick={toggleMessageVisibility}
									>
										{isMessageVisible ? (
											<>
												<div className="flex">
													<div className="pr-1">Hide Message</div>
													<IoIosArrowUp />
												</div>
											</>
										) : (
											<>
												<div className="flex">
													<div className="pr-1">View Message</div>
													<IoIosArrowDown />
												</div>
											</>
										)}
									</button>
								</div>
							</div>
							{/* <label
                htmlFor="toggle"
                className="ml-2 text-sm font-medium text-[#111827]"
              >
                Message Guest
              </label> */}
						</div>
						{/* Add Guest Button */}
						<button
							onClick={handleChangeStatus}
							className={`lg:ml-2 text-white font-semibold px-4 py-2 rounded-md text-[13px] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 ${
								checkInType1 === "Cancel Reservation" ||
								checkInType1 === "No Show"
									? "bg-rose-400 hover:bg-rose-500 focus-visible:outline-rose-400"
									: "bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
							}`}
						>
							{checkInType1 === "Cancel Reservation"
								? "Cancel Reservation "
								: checkInType1 === "No Show"
									? "No Show"
									: "Update"}
						</button>
					</div>
					<div className="w-full mt-2">
						{isMessageVisible && (
							<textarea
								value={message}
								onChange={(e) => setMessage(e.target.value)}
								className="block w-full rounded-md border border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 resize-none overflow-y-auto text-[13px] placeholder:text-gray-900"
								rows={3}
								placeholder="Default status message template text goes here and not editable..."
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default EditGuestModal;
